import { Component,ElementRef, ViewChild, OnInit } from '@angular/core';
import { GlobalConstants } from '../../../common/constants/global.constant';

@Component({
  selector: 'iposcen-ipos-help-installing-chromebook',
  templateUrl: './ipos-help-installing-chromebook.component.html',
  styleUrls: ['./ipos-help-installing-chromebook.component.scss']
})
export class IposHelpInstallingChromebookComponent implements OnInit {
  @ViewChild('installChrome') installChrome: ElementRef;
  @ViewChild('sectionA') sectionA: ElementRef;
  @ViewChild('sectionB') sectionB: ElementRef;
  @ViewChild('sectionC') sectionC: ElementRef;
  @ViewChild('sectionD') sectionD: ElementRef;
  isSectionA = true;
  isSectionB = true;
  isSectionC = true;
  isSectionD = true;
  installingChromeText = GlobalConstants.INSTALLING_CHROMEBOOK_HELP_TITLE_TEXT;
  constructor() { }

  ngOnInit(): void {
  }

  change(data) {
    if (data === 'installChrome') {
      setTimeout(() => {
        this.installChrome.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'installChrome_sectionA') {
      setTimeout(() => {
        this.sectionA.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'installChrome_sectionC') {
      setTimeout(() => {
        this.sectionC.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'installChrome_sectionD') {
      setTimeout(() => {
        this.sectionD.nativeElement.scrollIntoView();
      }, 0);
    }
  }

  showDescription(data) {
    if (data === 'sectionA') {
      this.isSectionA = !this.isSectionA;
    } else if (data === 'sectionB') {
      this.isSectionB = !this.isSectionB;
    } else if (data === 'sectionC') {
      this.isSectionC = !this.isSectionC;
    } else if (data === 'sectionD') {
      this.isSectionD = !this.isSectionD;
    }
  }

}
